import React, { useEffect, useState } from 'react';
import { checkProivderStatus, getAllProviders } from '../../../config/LiveApi';
import { useSelector } from 'react-redux';

const CheckProvider = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [statusMap, setStatusMap] = useState({});
  const [checkingMap, setCheckingMap] = useState({});

  useEffect(() => {
    const fetchAllProviders = async () => {
      try {
        const response = await getAllProviders(token);
        setTableData(response?.data?.data || []);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllProviders();
  }, []);

  const handleCheckProviderStatus = async (id) => {
    setCheckingMap((prev) => ({ ...prev, [id]: true }));
    try {
      const response = await checkProivderStatus(token, id);
      const isActive = response?.status === 200;
      setStatusMap((prev) => ({
        ...prev,
        [id]: isActive ? 'Healthy' : 'Unhealthy',
      }));
    } catch (error) {
      console.log(error);
      setStatusMap((prev) => ({
        ...prev,
        [id]: 'Unhealthy',
      }));
    } finally {
      setCheckingMap((prev) => ({ ...prev, [id]: false }));
    }
  };

  return (
    <>
    <div className='main-heading'>
    <h2>Check Provider Status</h2>
      {isLoading ? (
          <p>Loading...</p>
        ) : (
            <table className="settlement-table">
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Organization Name</th>
              <th>Health Status</th>
              <th>Check Health Status</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((provider) => (
                <tr key={provider.id}>
                <td>{provider.providerName}</td>
                <td>{provider.orgName}</td>
                <td>
                  {statusMap[provider.id] ? (
                      <span
                      style={{
                          color:
                          statusMap[provider.id] === 'Healthy'
                          ? 'green'
                          : statusMap[provider.id] === 'Unhealthy'
                          ? 'red'
                          : 'gray',
                        }}
                        >
                      {statusMap[provider.id]}
                    </span>
                  ) : (
                      '--'
                    )}
                </td>
                <td>
                  <button
                    style={{
                        backgroundColor: '#FC8019',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '5px',
                        cursor: checkingMap[provider.id] ? 'not-allowed' : 'pointer',
                        opacity: checkingMap[provider.id] ? 0.7 : 1,
                    }}
                    onClick={() => handleCheckProviderStatus(provider.id)}
                    disabled={checkingMap[provider.id]}
                    >
                    {checkingMap[provider.id] ? 'Checking...' : 'Check'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </div>
    </>
  );
};

export default CheckProvider;
